/**
 * Registers framework-specific fetchers for the home page project widget.
 * Each web-assessment-charts-*.js (NIST/CIS/NYCRR) calls
 * registerHomeDashboardFetcher(taxonomySlug, fetchFn) from its own scope
 * so home-dashboard-dispatch can route by project's framework term slug
 * without relying on the global fetchDataAndCalculateScores (which the CRF-S
 * files also reassign).
 */
(function (window) {
    'use strict';

    var NS = (window.WebAssessmentCharts = window.WebAssessmentCharts || {});
    var registry = Object.create(null);

    NS.registerHomeDashboardFetcher = function (frameworkSlug, fetchFn) {
        var key = String(frameworkSlug || '').toLowerCase();
        if (!key || typeof fetchFn !== 'function') return;
        registry[key] = fetchFn;
    };

    NS.homeDashboardHasFetcher = function (frameworkSlug) {
        return typeof registry[String(frameworkSlug || '').toLowerCase()] === 'function';
    };

    NS.homeDashboardFetchNonCrfs = function (projectSlug, frameworkSlug) {
        var fn = registry[String(frameworkSlug || '').toLowerCase()];
        if (typeof fn !== 'function') {
            return Promise.reject(new Error('No home dashboard fetcher for framework: ' + frameworkSlug));
        }
        return Promise.resolve(fn.call(NS, projectSlug));
    };

    /**
     * Show/hide framework panel roots: when #home-widget-project-dashboard exists,
     * only that subtree is toggled so /home cannot reveal duplicate containers
     * (e.g. view-results modals) that share the same class names.
     */
    NS.applyHomeScopedVisibility = function (jqueryMethod, selector) {
        var $w = jQuery('.home-widget-project-dashboard');
        var $set = $w.length ? $w.find(selector) : jQuery(selector);
        $set[jqueryMethod]();
    };
})(window);
